import { isNil, split } from 'lodash/fp'

export type ConfigProps = Record<string, any>

export const hasConfig = (
  config: Record<string, any>,
  keys: string
): boolean => {
  if (isNil(config)) return false
  let item = config
  for (const key of split('.')(keys)) {
    if (isNil(item[key])) return false
    item = item[key]
  }
  return true
}
